export enum NotificationTypeEnum {
    SUCCESS,
    ERROR,
    WARNING,
}
